module.exports = __webpack_public_path__ + "img/VillaLoreto_Hotel2.25626220.jpg";